const GameVersion = `0.3.0`;
const BuildDate = "03-10-2024 12:10"
export{GameVersion, BuildDate}